import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz32 = () => {
    return (
        <div>
            <NavLink to='/category/Puzzels/Puzzel33'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel31'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">Completion of Task</h1>
    
    <div class="text">
        <p>A man is allocated a task. He doubles the task done everyday. If the man completely does the task in 18 days,
            how many days did it take for the man to complete 25% of the task?&nbsp;</p>
        <div className='containers'>
        <p><strong>Answer</strong>: 16&nbsp;</p>
        <p>100% of task = 18 days&nbsp;</p>
        <p>As he doubles the task everyday. So,&nbsp;</p>
        <p>50% of task = 17 days&nbsp;</p><br/>
        <div id="AP_G4GR_5"></div>
        
        <p>25% of task = 16 days.&nbsp;</p>
        </div>
        <p><strong>Alternative Solution :</strong></p>
        <div className='containers'>
        <p>Let the amount of work the man did on first day be <strong>x</strong> and total work to be done be
            <strong>S</strong>.</p>
        <p>As the amount of work he did on next day would be 2 times of it’s previous day, we can write amount of work
            he did on 2<sup>nd </sup>day as ‘2x’, 3<sup>rd</sup> day ‘4x’, 4<sup>th</sup> day ‘8x’ and so on….</p>
        <p>We can write it as a GP as follows :&nbsp;</p>
        <p>S = x+2x+4x+8x+….. (till 18<sup>th</sup> day)</p>
        <p>S = x*(2<sup>18</sup>-1)/(2-1) &nbsp; &nbsp;[Formula of summation of GP S=a(r<sup>n</sup>-1)/(r-1)]</p>
        <p>S=x*(2<sup>18</sup>-1) &nbsp; &nbsp;– &nbsp;&nbsp;<i>equation (1)</i></p>
        <p>According to ques we have to find the day when he would complete 25% of the total work, then ‘S’ becomes
            ‘S/4’</p><br/>
       
        <p>We can write the expression as</p>
        <p>S/4 = x+2x+4x+8x+…. &nbsp;(till n<sup>th</sup> day)</p>
        <p>S/4=x*(2<sup>n</sup>-1)/(2-1)</p>
        <p>S/4=x*(2<sup>n</sup>-1)</p>
        <p>Substituting value of S from <i>equation (1)</i></p>
        <p><i>x*(2<sup>18</sup>-1)/4=x*(2<sup>n</sup>-1)</i></p>
        <p><i>On simplifying</i></p>
        <p><i>2<sup>18</sup>-1=4*(2<sup>n</sup>-1)</i></p>
        <p><i>2<sup>18</sup>-1=2<sup>n</sup>*4-4</i></p>
        <p><i>2<sup>n+2</sup>=2<sup>18</sup>+3 &nbsp;
                &nbsp;(2<sup>n</sup>*4=2<sup>n</sup>*2<sup>2</sup>=2<sup>n+2</sup>)</i></p>
        <p>We can neglect 3 in comparison of 2<sup>18</sup></p>
        <p>2<sup>n+2</sup>=2<sup>18</sup></p>
        <p>n+2=18</p>
        <p>n=16 days</p>
        <p>So answer is 16 days.</p>
        </div>
    </div>
</article>
        </div>
    )
}

export default Puz32
